<ng-template #template>
    <div class="modal-header">
      <h4 class="modal-title">
        {{'Confirm' | translate}}
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="confirm(false)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>{{ Message | translate }}</div>
      <button type="button" class="btn btn-sm btnDelete mr-2" (click)="confirm(true)">
        {{btnLabel | translate}}
      </button>
      <button type="button" class="btn btn-sm btnCancel" (click)="confirm(false)">
        {{cancelBtnLabel | translate}}
      </button>
    </div>
</ng-template>
